/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import logo from './logo.svg';
import './App.css';
import AppHeader from "./components/header/Header";
import ProductList from "./components/cards/ProductList";
import {useState} from "react";
import Cart from "./components/cart/Cart";

function App() {

    return (
    <main>
      <AppHeader />
        <ProductList/>


    </main>
  );
}

export default App;
